import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import ChartFormFonts from './ChartFormFont'
import ChartFormStyle from './ChartFormStyle'
import type { ChartFormBrandType, ChartBrandForms } from './chartTypes'

const FORM_MAP: ChartBrandForms = {
  [BrandFormEnum.STYLE]: ChartFormStyle,
  ...ChartFormFonts,
}

const ChartFormBrand: ChartFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(ChartFormBrand) as typeof ChartFormBrand
